import React, { FC } from 'react';
import { TFunction } from 'react-i18next';
import { Box, Button } from '@dxb-web-ui-framework/design-system';
import { Web as WebIcon, Visibility as VisibilityIcon } from '@dxb-web-ui-framework/design-system/dist/icons';
import { useScreenDetector } from '@dxb-web-ui-framework/common/hooks';

export type ActionsProps = {
  navigateToDashboard: () => void;
  onToggleDetails: () => void;
  onToggleTemplate: () => void;
  t: TFunction;
  isLoading: boolean;
  showTemplateSaveBtn: boolean;
};

const Actions: FC<ActionsProps> = ({
  navigateToDashboard,
  onToggleDetails,
  onToggleTemplate,
  t,
  isLoading = true,
  showTemplateSaveBtn,
}) => {
  const { isExtraSmallScreen: isMobile } = useScreenDetector();

  return (
    <Box textAlign='center' maxWidth='210px' width='100%'>
      <Box mt={isMobile ? 0 : 6}>
        <Button
          color='primary'
          size='large'
          variant='contained'
          fullWidth
          onClick={navigateToDashboard}
          hasSkeleton={isLoading}>
          {t('fundsTransfer.SuccessStep.Button.primary')}
        </Button>
      </Box>
      <Box mt={isMobile ? 2 : 4} mb={isMobile ? 2 : 5}>
        <Button
          color='primary'
          size='large'
          variant='outlined'
          fullWidth
          onClick={onToggleDetails}
          hasSkeleton={isLoading}>
          {t('fundsTransfer.SuccessStep.Button.secondary')}{' '}
          <Box component='span' ml={1} pt={0.5}>
            <VisibilityIcon />
          </Box>
        </Button>
      </Box>
      {showTemplateSaveBtn && (
        <Box>
          <Button
            color='primary'
            size='small'
            startIcon={<WebIcon />}
            variant='text'
            onClick={onToggleTemplate}
            hasSkeleton={isLoading}>
            {t('fundsTransfer.SuccessStep.Button.text')}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export { Actions };
